import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalBody,
  ModalHeader,
  UncontrolledAccordion,
  AccordionItem,
  AccordionHeader,
  AccordionBody,
  Row,
  Col,
  Button,
} from "reactstrap";
// alerta
import SweetAlert from "react-bootstrap-sweetalert";
// router
import { useLocation } from "react-router-dom";
// redux
import { connect } from "react-redux";
// componentes
import ColorPicker from "../../../components/ColorPicker/ColorPicker";
import ButtonSpinner from "../../../components/Buttons/ButtonSpinner";
// service
import {
  getConfigLogistics,
  changeConfigLogistics,
} from "../../../utils/services/configLogistics";

function ModalConfigLogistics(props) {
  const { isOpen, toggle } = props;
  // location
  const location = useLocation();
  const idEvent = location.state.idEvent;
  // cores
  const [vooColorCard, setVooColorCard] = useState("#ffffff");
  const [vooColorText, setVooColorText] = useState("#ffffff");
  const [transferColorCard, setTransferColorCard] = useState("#ffffff");
  const [transferColorText, setTransferColorText] = useState("#ffffff");
  const [hotelColorCard, setHotelColorCard] = useState("#ffffff");
  const [hotelColorText, setHotelColorText] = useState("#ffffff");
  const [idConfig, setIdConfig] = useState(null);
  // tipo de requisição
  const [typeRequest, setTypeRequest] = useState("post");
  // alerta
  const [success, setSuccess] = useState(false);
  // carregando
  const [loadingConfig, setLoadingConfig] = useState(true);
  const [loading, setLoading] = useState(false);
  // erros
  const [errors, setErrors] = useState({});

  function checkItemMenuExists(menuOption) {
    return (
      props.state.global_user_data.data.foundProducts.filter(
        (item) => item.name === menuOption,
      ).length > 0
    );
  }

  function verifyForm() {
    if (checkItemMenuExists("VOO") && vooColorCard === vooColorText) {
      setErrors({ voo: "As cores de card e texto não podem ser iguais" });
      return;
    } else setErrors("");

    if (
      checkItemMenuExists("TRANSFER") &&
      transferColorCard === transferColorText
    ) {
      setErrors({ transfer: "As cores de card e texto não podem ser iguais" });
      return;
    } else setErrors("");

    if (checkItemMenuExists("HOTEL") && hotelColorCard === hotelColorText) {
      setErrors({ hotel: "As cores de card e texto não podem ser iguais" });
      return;
    } else setErrors("");

    submitForm();
  }

  async function submitForm() {
    setLoading(true);
    const data = {
      eventId: idEvent,
      flightCardColor: vooColorCard,
      flightFontColor: vooColorText,
      hotelCardColor: hotelColorCard,
      hotelFontColor: hotelColorText,
      transferCardColor: transferColorCard,
      transferFontColor: transferColorText,
    };

    try {
      const res = await changeConfigLogistics(data, typeRequest, idConfig);

      if (res?.message === "created" || res?.message === "updated") {
        setSuccess(true);
      }
    } catch (error) {
      // console.log("erro", error);
    } finally {
      setLoading(false);
    }
  }

  async function getConfig() {
    getConfigLogistics(idEvent).then((res) => {
      if (
        res?.message === "getLogisticsConfig" &&
        res?.getLogisticsConfig?.data[0]
      ) {
        const data = res.getLogisticsConfig.data[0];

        setTypeRequest("put");
        setVooColorCard(data.flightCardColor);
        setVooColorText(data.flightFontColor);
        setTransferColorCard(data.transferCardColor);
        setTransferColorText(data.transferFontColor);
        setHotelColorCard(data.hotelCardColor);
        setHotelColorText(data.hotelFontColor);
        setIdConfig(data.id);
      }

      setLoadingConfig(false);
    });
    // .catch((error) => console.log("erro", error));
  }

  useEffect(() => {
    getConfig();
  }, []);

  return (
    <>
      {success && (
        <SweetAlert
          success
          title="Sucesso"
          onConfirm={() => {
            setSuccess(false);
            toggle();
          }}
        >
          Configuração alterada com sucesso
        </SweetAlert>
      )}

      <Modal isOpen={isOpen} centered>
        <ModalHeader toggle={toggle}>Configurar Logística</ModalHeader>
        <ModalBody>
          {loadingConfig ? (
            <div style={{ width: "100%", textAlign: "center" }}>
              <a>Carregando ...</a>
            </div>
          ) : (
            <>
              {checkItemMenuExists("VOO") && (
                <>
                  <label style={{ marginBottom: 0 }} className="form-label">
                    Voo
                  </label>
                  <Row style={{ marginBottom: 20 }}>
                    <Col md={6}>
                      <ColorPicker
                        classOfContainer="vooColorCard"
                        labelText="Cor do Card"
                        setStateFunc={setVooColorCard}
                        defaultColor={vooColorCard}
                        idDiv={"vooColorCard"}
                      />
                    </Col>

                    <Col md={6}>
                      <ColorPicker
                        classOfContainer="vooColorText"
                        labelText="Cor do Texto"
                        setStateFunc={setVooColorText}
                        defaultColor={vooColorText}
                        idDiv={"vooColorText"}
                      />
                    </Col>
                    {errors && errors.voo && (
                      <a style={{ color: "red" }}>{errors.voo}</a>
                    )}
                  </Row>
                </>
              )}

              {checkItemMenuExists("TRANSFER") && (
                <>
                  <label style={{ marginBottom: 0 }} className="form-label">
                    Transfer
                  </label>
                  <Row style={{ marginBottom: 20 }}>
                    <Col md={6}>
                      <ColorPicker
                        classOfContainer="transferColorCard"
                        labelText="Cor do Card"
                        setStateFunc={setTransferColorCard}
                        defaultColor={transferColorCard}
                        idDiv={"transferColorCard"}
                      />
                    </Col>

                    <Col md={6}>
                      <ColorPicker
                        classOfContainer="transferColorText"
                        labelText="Cor do Texto"
                        setStateFunc={setTransferColorText}
                        defaultColor={transferColorText}
                        idDiv={"transferColorText"}
                      />
                    </Col>
                    {errors && errors.transfer && (
                      <a style={{ color: "red" }}>{errors.transfer}</a>
                    )}
                  </Row>
                </>
              )}

              {checkItemMenuExists("HOTEL") && (
                <>
                  <label style={{ marginBottom: 0 }} className="form-label">
                    Hotel
                  </label>
                  <Row>
                    <Col md={6}>
                      <ColorPicker
                        classOfContainer="hotelColorCard"
                        labelText="Cor do Card"
                        setStateFunc={setHotelColorCard}
                        defaultColor={hotelColorCard}
                        idDiv={"hotelColorCard"}
                      />
                    </Col>

                    <Col md={6}>
                      <ColorPicker
                        classOfContainer="hotelColorText"
                        labelText="Cor do Texto"
                        setStateFunc={setHotelColorText}
                        defaultColor={hotelColorText}
                        idDiv={"hotelColorText"}
                      />
                    </Col>
                    {errors && errors.hotel && (
                      <a style={{ color: "red" }}>{errors.hotel}</a>
                    )}
                  </Row>
                </>
              )}

              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginTop: 20,
                }}
              >
                <Button
                  color="danger"
                  className="save-btn-form"
                  style={{ width: 80 }}
                  onClick={() => toggle()}
                >
                  Fechar
                </Button>
                <ButtonSpinner
                  isLoading={loading}
                  title={"Salvar"}
                  marginLeft={10}
                  action="C"
                  onClick={() => verifyForm()}
                  className="btn btn-success waves-effect waves-light save-btn-form"
                />
              </div>
            </>
          )}
        </ModalBody>
      </Modal>
    </>
  );
}

const mapStateToProps = (state) => {
  return { state };
};

export default connect(mapStateToProps)(ModalConfigLogistics);
